export default __webpack_public_path__ + "static/media/fphoto1.91a35d03.jpeg";